export enum PAYMENT_PROVIDER {
    PAYSTACK = 'PAYSTACK',
    PAYLOFT = 'PAYLOFT',
    // Spelled as the backend spells it, in allProviders and its /firstchekout paths.
    FIRSTCHEKOUT = 'FIRSTCHEKOUT',
}